import { render, staticRenderFns } from "./ModalIgnoreReservation.vue?vue&type=template&id=104135c2&scoped=true"
import script from "./ModalIgnoreReservation.vue?vue&type=script&lang=ts"
export * from "./ModalIgnoreReservation.vue?vue&type=script&lang=ts"
import style0 from "./ModalIgnoreReservation.vue?vue&type=style&index=0&id=104135c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104135c2",
  null
  
)

export default component.exports